<div class="navigation-menu-panel" [style.--header-panel-height]="headerHeight">
  <div class="navigation-menu-panel__content">
    @for (navigationItem of topNavigationItems(); track navigationItem.id) {
      @switch (navigationItem.id) {
        @case (TopNavigationPath.KaseyaStore) {
          @let isKaseyaStoreSsoLinkLoading = isKaseyaStoreSsoLinkLoading$ | async;

          <button
            *itcPermission="navigationItem.permissions"
            type="button"
            class="navigation-menu-panel__item"
            [class.navigation-menu-panel__item--loading]="isKaseyaStoreSsoLinkLoading"
            [itcOpenSsoLink]="SsoTargetPage.KaseyaStore"
            [isLoading$]="isKaseyaStoreSsoLinkLoading$"
          >
            <i aria-hidden="true" [class]="navigationItem.iconClass"></i>
            <span class="navigation-menu-panel__item-label">
              {{ navigationItem.labelTranslateKey | translate }}
            </span>

            @if (isKaseyaStoreSsoLinkLoading) {
              <kds-spinner variant="overlay" />
            } @else {
              <i aria-hidden="true" class="navigation-menu-panel__external-icon fa-regular fa-external-link"></i>
            }
          </button>
        }
        @case (TopNavigationPath.KaseyaInsights) {
          <ng-container *itcFeature="navigationItem.features">
            <div *itcPermission="navigationItem.permissions" class="navigation-menu-panel__item-link">
              <itc-navigation-link
                [iconClass]="navigationItem.iconClass"
                [linkName]="navigationItem.labelTranslateKey | translate"
                [topNavigation]="navigationItem.id"
                [id]="navigationItem.id"
                (click)="isOpen.set(false)"
              />
            </div>
          </ng-container>
        }
        @default {
          @let isActive = navigationItem.id === activeTopNavigation();

          <button
            *itcPermission="navigationItem.permissions"
            type="button"
            class="navigation-menu-panel__item"
            [attr.aria-expanded]="!navigationItem?.isCollapsed()"
            (click)="toggleNavigationItem(navigationItem)"
          >
            <i aria-hidden="true" [class]="navigationItem.iconClass"></i>
            <span class="navigation-menu-panel__item-label" [class.navigation-menu-panel__item-label--bold]="isActive">
              {{ navigationItem.labelTranslateKey | translate }}
            </span>
            <i
              aria-hidden="true"
              class="navigation-menu-panel__toggle-icon fa-regular fa-chevron-down"
              [class.navigation-menu-panel__toggle-icon--expanded]="!navigationItem?.isCollapsed()"
            ></i>
          </button>

          @if (!navigationItem?.isCollapsed()) {
            <itc-left-navigation
              [topNavigation]="navigationItem.id"
              [@toggleContentFadeIn]="true"
              [@toggleContentFadeOut]="true"
              [isMobileView]="true"
              (navigationItemClick)="isOpen.set(false)"
            />
          }
        }
      }
    }
  </div>

  <div class="navigation-menu-panel__footer">
    <itc-account-team-panel *itcPermission="Permission.AccountTeamView" [isMobileView]="true" (viewTeamClick)="isOpen.set(false)" />
  </div>
</div>
